// import React from "react";
// import { Card, CardContent, Typography, Button, Box } from "@mui/material";
// import {
//   CalendarToday,
//   Assignment,
//   QueuePlayNext,
//   People,
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { useNavigate } from "react-router-dom";

// // Styles object for the card component
// const styles = {
//   card: {
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     boxShadow: "0 10px 15px rgba(0,0,0,0.05)",
//     borderRadius: 3,
//     transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
//     "&:hover": {
//       transform: "translateY(-5px)",
//       boxShadow: "0 12px 20px rgba(37, 99, 235, 0.12)",
//     },
//     overflow: "hidden",
//     position: "relative",
//   },
//   blueStrip: {
//     height: 6,
//     bgcolor: "#2563eb",
//     width: "100%",
//   },
//   cardContent: {
//     p: 3,
//     flexGrow: 1,
//     display: "flex",
//     flexDirection: "column",
//   },
//   cardTitle: {
//     color: "#1e3a8a",
//     fontWeight: 600,
//     mb: 1,
//   },
//   cardDescription: {
//     color: "#475569",
//     mb: 2,
//     flexGrow: 1,
//   },
//   infoBox: {
//     bgcolor: "#f1f5f9",
//     p: 2,
//     borderRadius: 2,
//     mb: 2,
//   },
//   infoText: {
//     display: "flex",
//     alignItems: "center",
//     color: "#334155",
//     fontSize: "0.875rem",
//     mb: 1,
//   },
//   icon: { mr: 1, fontSize: 16, color: "#2563eb" },
//   outlineButton: {
//     borderColor: "#2563eb",
//     color: "#2563eb",
//     borderRadius: 2,
//     "&:hover": {
//       borderColor: "#1d4ed8",
//       bgcolor: "rgba(37, 99, 235, 0.04)",
//     },
//   },
//   primaryButton: {
//     bgcolor: "#2563eb",
//     "&:hover": { bgcolor: "#1d4ed8" },
//     borderRadius: 2,
//     boxShadow: "0 2px 4px rgba(37, 99, 235, 0.2)",
//     "&.Mui-disabled": {
//       bgcolor: "#e2e8f0",
//       color: "#94a3b8",
//     },
//   },
//   ticketBox: {
//     p: 2,
//     bgcolor: "#dbeafe",
//     borderRadius: 2,
//     position: "relative",
//     overflow: "hidden",
//   },
//   ticketStrip: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: 4,
//     height: "100%",
//     bgcolor: "#2563eb",
//   },
//   ticketPosition: {
//     color: "#1e40af",
//     fontWeight: 500,
//     mb: 1,
//     pl: 1,
//   },
//   statusMessage: (isSuccess) => ({
//     mt: 1,
//     p: 1,
//     borderRadius: 1,
//     fontSize: "0.75rem",
//     display: "block",
//     bgcolor: isSuccess ? "#dcfce7" : "#fee2e2",
//     color: isSuccess ? "#166534" : "#b91c1c",
//   }),
//   fileInfo: {
//     color: "#475569",
//     fontSize: "0.75rem",
//     textOverflow: "ellipsis",
//     overflow: "hidden",
//     whiteSpace: "nowrap",
//   },
// };

// const CandidateCard = ({
//   carnival,
//   userId,
//   fileState,
//   hasTicket,
//   ticket,
//   onFileSelect,
//   onGetTicket,
//   isDeadlinePassed,
// }) => {
//   const navigate = useNavigate();

//   return (
//     <Card sx={styles.card}>
//       <Box sx={styles.blueStrip} />
//       <CardContent sx={styles.cardContent}>
//         <Typography variant="h6" sx={styles.cardTitle}>
//           {carnival.title}
//         </Typography>
//         <Typography sx={styles.cardDescription}>
//           {carnival.description}
//         </Typography>

//         <Box sx={styles.infoBox}>
//           <Typography sx={styles.infoText}>
//             <CalendarToday sx={styles.icon} />
//             <strong>Deadline:</strong>{" "}
//             {format(new Date(carnival.deadline), "MMM dd yyyy 'at' h:mm aa")}
//           </Typography>
//           <Typography sx={styles.infoText}>
//             <CalendarToday sx={styles.icon} />
//             <strong>Start:</strong>{" "}
//             {format(new Date(carnival.start_time), "MMM dd yyyy 'at' h:mm aa")}
//           </Typography>
//         </Box>
//         <Box sx={{ flex: 1 }}>
//           <Typography variant="h6" component="h3" sx={styles.sectionTitle}>
//             <People sx={styles.largeIcon} /> Participation
//           </Typography>
//           <Box sx={{ ml: 3, bgcolor: "#f1f5f9", p: 2, borderRadius: 2 }}>
//             <Typography variant="body1" sx={{ mb: 1, color: "#334155" }}>
//               <strong>Maximum Participants:</strong> {carnival.max_participants}
//             </Typography>
//           </Box>
//         </Box>

//         {!isDeadlinePassed(carnival.deadline) ? (
//           !hasTicket ? (
//             <Box>
//               <input
//                 type="file"
//                 accept=".pdf,.doc,.docx"
//                 onChange={(e) => onFileSelect(e, carnival.id)}
//                 style={{ display: "none" }}
//                 id={`cv-upload-${carnival.id}`}
//               />
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 1,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: 1,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <label htmlFor={`cv-upload-${carnival.id}`}>
//                     <Button
//                       variant="outlined"
//                       component="span"
//                       startIcon={<Assignment />}
//                       size="small"
//                       sx={styles.outlineButton}
//                     >
//                       Select CV
//                     </Button>
//                   </label>
//                   <Button
//                     variant="contained"
//                     size="small"
//                     onClick={() => onGetTicket(carnival.id)}
//                     disabled={!fileState?.selectedFile}
//                     startIcon={<QueuePlayNext />}
//                     sx={{ ...styles.primaryButton, flexGrow: 1 }}
//                   >
//                     Get Ticket
//                   </Button>
//                 </Box>
//                 {fileState?.selectedFile && (
//                   <Typography sx={styles.fileInfo}>
//                     {fileState.selectedFile.name}
//                   </Typography>
//                 )}
//               </Box>
//               {fileState?.status && (
//                 <Typography
//                   sx={styles.statusMessage(
//                     fileState.status.includes("successfully")
//                   )}
//                 >
//                   {fileState.status}
//                 </Typography>
//               )}
//             </Box>
//           ) : (
//             <Box sx={styles.ticketBox}>
//               <Box sx={styles.ticketStrip} />
//               <Typography sx={styles.ticketPosition}>
//                 Queue Position: <strong>{ticket.queue_position}</strong>
//               </Typography>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 onClick={() => {
//                   const encodedId = btoa(ticket.id.toString());
//                   navigate(`/interview-room/${encodedId}`);
//                 }}
//                 sx={styles.primaryButton}
//               >
//                 Enter Interview Room
//               </Button>
//             </Box>
//           )
//         ) : (
//           <Box
//             sx={{
//               mt: 2,
//               p: 2,
//               bgcolor: "#fee2e2",
//               borderRadius: 2,
//               position: "relative",
//               overflow: "hidden",
//             }}
//           >
//             <Box
//               sx={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: 4,
//                 height: "100%",
//                 bgcolor: "#dc2626",
//               }}
//             />
//             <Typography
//               sx={{
//                 color: "#991b1b",
//                 fontWeight: 500,
//                 fontSize: "0.9rem",
//               }}
//             >
//               Application deadline has passed
//             </Typography>
//           </Box>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// export default CandidateCard;
import React, { useState, useEffect } from "react";
import { Card, CardContent, Typography, Button, Box, Menu, MenuItem } from "@mui/material";
import {
  CalendarToday,
  Assignment,
  QueuePlayNext,
  People,
  Share,
  Download,
  ArrowDropDown,
} from "@mui/icons-material";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import ShareCarnivalDialog from "../recruiter/ShareCarnivalDialog";
import useCarnivalWebSocket from "hooks/useCarnivalWebSocket";
import useUserId from "hooks/useUserId";
import { useTranslation } from "react-i18next";

// Styles object for the card component
const styles = {
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 10px 15px rgba(0, 23, 231, 0.08)",
    borderRadius: 3,
    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
    border: "1px solid rgba(0, 23, 231, 0.1)",
    background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 20px rgba(0, 23, 231, 0.15)",
      borderColor: "rgba(0, 23, 231, 0.2)",
    },
    overflow: "hidden",
    position: "relative",
  },
  blueStrip: {
    height: 6,
    background: "linear-gradient(45deg, #0017E7 30%, #1e40af 90%)",
    width: "100%",
  },
  cardContent: {
    p: 3,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  cardTitle: {
    color: "#0017E7",
    fontWeight: 600,
    mb: 1,
  },
  cardDescription: {
    color: "#475569",
    mb: 2,
    flexGrow: 1,
  },
  infoBox: {
    bgcolor: "#f1f5f9",
    p: 2,
    borderRadius: 2,
    mb: 2,
  },
  infoText: {
    display: "flex",
    alignItems: "center",
    color: "#334155",
    fontSize: "0.875rem",
    mb: 1,
  },
  icon: { mr: 1, fontSize: 16, color: "#0017E7" },
  outlineButton: {
    borderColor: "#0017E7",
    color: "#0017E7",
    borderRadius: 2,
    "&:hover": {
      borderColor: "#0010a3",
      bgcolor: "rgba(0, 23, 231, 0.04)",
    },
  },
  primaryButton: {
    background: "linear-gradient(45deg, #0017E7 30%, #1e40af 90%)",
    "&:hover": {
      background: "linear-gradient(45deg, #0010a3 30%, #1e3a8a 90%)",
      transform: "translateY(-1px)",
    },
    borderRadius: 2,
    boxShadow: "0 2px 4px rgba(0, 23, 231, 0.2)",
    transition: "all 0.2s ease-in-out",
    "&.Mui-disabled": {
      bgcolor: "#e2e8f0",
      color: "#94a3b8",
    },
  },
  ticketBox: {
    p: 2,
    bgcolor: "rgba(0, 23, 231, 0.05)",
    borderRadius: 2,
    position: "relative",
    overflow: "hidden",
    border: "1px solid rgba(0, 23, 231, 0.1)",
  },
  ticketStrip: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 4,
    height: "100%",
    background: "linear-gradient(45deg, #0017E7 30%, #1e40af 90%)",
  },
  ticketPosition: {
    color: "#0017E7",
    fontWeight: 500,
    mb: 1,
    pl: 1,
  },
  statusMessage: (isSuccess) => ({
    mt: 1,
    p: 1,
    borderRadius: 1,
    fontSize: "0.75rem",
    display: "block",
    bgcolor: isSuccess ? "#dcfce7" : "#fee2e2",
    color: isSuccess ? "#166534" : "#b91c1c",
  }),
  fileInfo: {
    color: "#475569",
    fontSize: "0.75rem",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  sectionTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1e3a8a",
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  largeIcon: {
    mr: 1,
    fontSize: 20,
    color: "#2563eb",
  },
  participantInfo: {
    display: "flex",
    alignItems: "center",
    color: "#334155",
    fontSize: "0.875rem",
  },
  participantData: {
    fontWeight: 600,
    color: "#1e40af",
  },
};

const CandidateCard = ({
  carnival,
  userId,
  fileState,
  hasTicket,
  ticket,
  onFileSelect,
  onGetTicket,
  isDeadlinePassed,
  showSnackbar,
  onSelectExistingCV,
}) => {
  const navigate = useNavigate();
  const { userId: userIdObject } = useUserId();
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_API_URL;

  // Extract user ID properly (use prop userId if available, otherwise extract from hook)
  const actualUserId =
    userId || userIdObject?.userId || userIdObject?.id || userIdObject;

  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [uploadedCVs, setUploadedCVs] = useState([]);
  const [cvMenuAnchor, setCvMenuAnchor] = useState(null);

  // Function to get user ID from access token
  const getUserIdFromAccessToken = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }
    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  };

  const parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  };

  // Fetch uploaded CVs
  const fetchUploadedCVs = async () => {
    const userId = getUserIdFromAccessToken();
    if (!userId) return;

    try {
      const response = await fetch(
        `${apiUrl}authentication/files-for-candidate/${userId}/`
      );
      if (!response.ok) {
        throw new Error(`An error occurred: ${response.statusText}`);
      }
      const json = await response.json();
      setUploadedCVs(json);
    } catch (error) {
      console.error("Error loading CVs:", error);
      setUploadedCVs([]);
    }
  };

  // Select existing CV function
  const handleSelectExistingCV = (cvData, carnivalId) => {
    let resume_path;
    
    if (typeof cvData === "string") {
      resume_path = cvData;
    } else if (cvData && typeof cvData === "object") {
      resume_path = cvData.resume || cvData.path || cvData.name;
    } else {
      console.error("Invalid CV data type", cvData);
      return;
    }

    if (!resume_path) {
      console.log("Resume path is not available");
      return;
    }

    // Create a mock file object that represents the selected CV
    const mockFile = {
      name: resume_path.split('/').pop() || 'resume.pdf',
      path: resume_path,
      isExistingCV: true, // Flag to identify this as an existing CV
      size: 0, // We don't have the actual size
      type: 'application/pdf', // Assume PDF for now
    };

    // Use the callback function to update the file state in the parent component
    if (onSelectExistingCV) {
      onSelectExistingCV(carnivalId, mockFile, resume_path);
    }

    // Close the menu
    setCvMenuAnchor(null);
  };

  // Local state for real-time updates
  const [currentParticipants, setCurrentParticipants] = useState(
    carnival.current_participants || 0
  );
  const [queuePosition, setQueuePosition] = useState(
    ticket?.queue_position || 0
  );
  const [candidatesAhead, setCandidatesAhead] = useState(0);

  // WebSocket connection for real-time updates
  const { carnivalData, queueInfo, isConnected } = useCarnivalWebSocket(
    carnival.id,
    actualUserId,
    {
      onParticipantUpdate: (data) => {
        console.log(`Participant update for carnival ${carnival.id}:`, data);
        setCurrentParticipants(data.current_participants);

        // Show notification for participant changes
        if (
          data.action === "ticket_created" &&
          data.new_candidate_id !== actualUserId
        ) {
          showSnackbar(t("candidates.newParticipantJoined", { title: carnival.title }), "info");
        }
      },
      onQueueUpdate: (data) => {
        console.log(`Queue update for carnival ${carnival.id}:`, data);

        // Show notification for queue changes
        if (data.action === "interview_completed") {
          showSnackbar(t("candidates.queuePositionChanged"), "info");
        } else if (
          data.action === "new_candidate_joined" &&
          data.new_candidate_id !== actualUserId
        ) {
          showSnackbar(t("candidates.newCandidateJoined"), "info");
        }
      },
      onStatusChange: (data) => {
        console.log(`Status change for carnival ${carnival.id}:`, data);
        if (data.is_archived) {
          showSnackbar(t("candidates.caravanArchived", { title: carnival.title }), "warning");
        }
      },
      onError: (error) => {
        console.error(`WebSocket error for carnival ${carnival.id}:`, error);
      },
      debug: process.env.NODE_ENV === "development",
    }
  );

  // Fetch uploaded CVs on component mount
  useEffect(() => {
    fetchUploadedCVs();
  }, []);

  // Update local state when WebSocket provides new data
  useEffect(() => {
    if (carnivalData && carnivalData.current_participants !== undefined) {
      setCurrentParticipants(carnivalData.current_participants);
    }
  }, [carnivalData]);

  useEffect(() => {
    if (queueInfo && hasTicket) {
      setQueuePosition(queueInfo.queue_position || 0);
      setCandidatesAhead(queueInfo.candidates_ahead || 0);
    }
  }, [queueInfo, hasTicket]);

  // Fallback to prop values if WebSocket data is not available
  const displayParticipants =
    carnivalData?.current_participants ?? currentParticipants;
  const displayQueuePosition =
    queueInfo?.queue_position ?? ticket?.queue_position;
  const displayCandidatesAhead = queueInfo?.candidates_ahead ?? candidatesAhead;
  const generateShareLink = () => {
    const baseUrl = window.location.origin;
    const encodedId = btoa(carnival.id.toString());
    return `${baseUrl}/carnival/${encodedId}`;
  };
  return (
    <Card sx={styles.card}>
      <Box sx={styles.blueStrip} />
      <CardContent sx={styles.cardContent}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="h6" sx={{ ...styles.cardTitle, mb: 0 }}>
            {carnival.title}
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<Share />}
            onClick={() => setShareDialogOpen(true)}
            sx={{
              minWidth: "auto",
              borderRadius: 6,
              bgcolor: "#2563eb", // Blue background
              color: "white",
              "&:hover": {
                bgcolor: "#1d4ed8", // Slightly darker blue on hover
              },
            }}
          >
            {t("carnivals.share")}
          </Button>
        </Box>
        <Typography sx={styles.cardDescription}>
          {carnival.description}
        </Typography>
        <Box sx={styles.infoBox}>
          <Typography sx={styles.infoText}>
            <CalendarToday sx={styles.icon} />
            <strong>{t("candidates.deadline")}:</strong>{" "}
            {format(new Date(carnival.deadline), "MMM dd yyyy 'at' h:mm aa")}
          </Typography>
          <Typography sx={styles.infoText}>
            <CalendarToday sx={styles.icon} />
            <strong>{t("candidates.startTime")}:</strong>{" "}
            {format(new Date(carnival.start_time), "MMM dd yyyy 'at' h:mm aa")}
          </Typography>
          <Typography sx={styles.participantInfo}>
            <People sx={styles.icon} />
            <strong>{t("candidates.maximumParticipants")}:</strong>{" "}
            <span style={{ marginLeft: "4px" }} sx={styles.participantData}>
              {carnival.max_participants}
            </span>
          </Typography>
        </Box>
        {hasTicket ? (
          <Box sx={styles.ticketBox}>
            <Box sx={styles.ticketStrip} />
            <Typography sx={styles.ticketPosition}>
              {t("candidates.queuePosition")}: <strong>{displayQueuePosition}</strong>
              {displayCandidatesAhead > 0 && (
                <Typography
                  variant="caption"
                  sx={{ display: "block", mt: 0.5, color: "#1e40af" }}
                >
                  {t("candidates.candidatesAhead")}: {displayCandidatesAhead}
                  {isConnected && (
                    <Box
                      component="span"
                      sx={{
                        ml: 1,
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        bgcolor: "success.main",
                        display: "inline-block",
                        animation: "pulse 2s infinite",
                      }}
                      title={t("candidates.realTimeUpdatesActive")}
                    />
                  )}
                </Typography>
              )}
            </Typography>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                const encodedId = btoa(ticket.id.toString());
                navigate(`/interview-room/${encodedId}`);
              }}
              sx={styles.primaryButton}
            >
              {t("candidates.enterInterviewRoom")}
            </Button>
          </Box>
        ) : !isDeadlinePassed(carnival.deadline) ? (
          <Box>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={(e) => onFileSelect(e, carnival.id)}
              style={{ display: "none" }}
              id={`cv-upload-${carnival.id}`}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <label htmlFor={`cv-upload-${carnival.id}`}>
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<Assignment />}
                    size="small"
                    sx={styles.outlineButton}
                  >
                    {t("candidates.selectCv")}
                  </Button>
                </label>
                
                {/* Show Select CV button if user has uploaded CVs but no local file selected */}
                {Object.keys(uploadedCVs).length > 0 && !fileState?.selectedFile && (
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<Assignment />}
                    endIcon={<ArrowDropDown />}
                    onClick={(e) => setCvMenuAnchor(e.currentTarget)}
                    sx={{
                      ...styles.outlineButton,
                      borderColor: "#10b981",
                      color: "#10b981",
                      "&:hover": {
                        borderColor: "#059669",
                        bgcolor: "rgba(16, 185, 129, 0.04)",
                      },
                    }}
                  >
                    Choisir un CV existant
                  </Button>
                )}
                
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => onGetTicket(carnival.id)}
                  disabled={!fileState?.selectedFile}
                  startIcon={<QueuePlayNext />}
                  sx={{ ...styles.primaryButton, flexGrow: 1 }}
                >
                  {t("candidates.getTicket")}
                </Button>
              </Box>
              {fileState?.selectedFile && (
                <Typography sx={styles.fileInfo}>
                  {fileState.selectedFile.name}
                </Typography>
              )}
            </Box>
            {fileState?.status && (
              <Typography
                sx={styles.statusMessage(
                  fileState.status.includes("successfully")
                )}
              >
                {fileState.status}
              </Typography>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor: "#fee2e2",
              borderRadius: 2,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: 4,
                height: "100%",
                bgcolor: "#dc2626",
              }}
            />
            <Typography
              sx={{
                color: "#991b1b",
                fontWeight: 500,
                fontSize: "0.9rem",
              }}
            >
              {t("candidates.applicationDeadlinePassed")}
            </Typography>
          </Box>
        )}
        <ShareCarnivalDialog
          open={shareDialogOpen}
          onClose={() => setShareDialogOpen(false)}
          shareLink={generateShareLink()}
          sharedCarnival={carnival}
          showSnackbar={showSnackbar || ((message) => console.log(message))}
        />
        
        {/* CV Selection Menu */}
        <Menu
          anchorEl={cvMenuAnchor}
          open={Boolean(cvMenuAnchor)}
          onClose={() => setCvMenuAnchor(null)}
          PaperProps={{
            sx: {
              maxHeight: 300,
              minWidth: 200,
            },
          }}
        >
          {Object.entries(uploadedCVs).map(([key, cvData]) => (
            <MenuItem
              key={key}
              onClick={() => {
                handleSelectExistingCV(cvData, carnival.id);
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: 1.5,
              }}
            >
              <Assignment fontSize="small" />
              <Typography variant="body2" sx={{ flexGrow: 1 }}>
                {cvData.resume ? cvData.resume.split('/').pop() : `CV ${key}`}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </CardContent>
    </Card>
  );
};

export default CandidateCard;